import { isExpired } from "react-jwt";
import axios from "axios";
import {
    REACT_APP_BASEURL_DEV,
    REACT_APP_BASEURL_QA,
    REACT_APP_BASEURL_PRD,
    REACT_APP_BASEURL_SRV_MAESTROS,
    REACT_APP_BASEURL_TRABAJADOR,
    REACT_APP_SEGURIDAD,
    REACT_APP_SEGURIDAD_USER,
    REACT_APP_SEGURIDAD_PASS,
    REACT_APP_LLAVE,
    REACT_APP_TOKEN,
    REACT_APP_EPAYCO_LLAVE,
    REACT_APP_BASEURL_EMPRESAS,
    REACT_APP_BASEURL_AKS} from "../../parametros"
import { Iestado } from ".";

interface tramaSeguridad{
    identificador : string,
    clave: string,
    appLlave : string
    appToken : string
}

const baseUrl = () => {
    let base = ""
    if(window.location.hostname === "localhost"){
        base = REACT_APP_BASEURL_DEV+"";
    }else if (window.location.hostname === "recaudos-qa.comfenalco.com"){
        base = REACT_APP_BASEURL_QA+"";
    }else if (window.location.hostname === "recaudos.comfenalco.com"){
        base = REACT_APP_BASEURL_PRD+"";
    }else if (window.location.hostname === "recaudos-aks.comfenalco.com"){
        base = REACT_APP_BASEURL_AKS+"";
    }
    return base;
}

const baseUrl_tDocumento = () => {
    let base = ""
    if(window.location.hostname === "localhost"){
        base = REACT_APP_BASEURL_DEV+"";
    }else if (window.location.hostname === "recaudos-qa.comfenalco.com"){
        base = REACT_APP_BASEURL_QA+"";
    }else if (window.location.hostname === "recaudos.comfenalco.com"){
        base = REACT_APP_BASEURL_PRD+"";
    }else if (window.location.hostname === "recaudos-aks.comfenalco.com"){
        base = REACT_APP_BASEURL_AKS+"";
    }
    return base+"TipoDocumento";
}

const baseUrl_seguridad = () => {
    let base = ""
    if(window.location.hostname === "localhost"){
        base = REACT_APP_BASEURL_DEV+"";
    }else if (window.location.hostname === "recaudos-qa.comfenalco.com"){
        base = REACT_APP_BASEURL_QA+"";
    }else if (window.location.hostname === "recaudos.comfenalco.com"){
        base = REACT_APP_BASEURL_PRD+"";
    }else if (window.location.hostname === "recaudos-aks.comfenalco.com"){
        base = REACT_APP_BASEURL_AKS+"";
    }
    return base+"auth";
}

const baseUrl_trabajador = () => {
    let base = ""
    if(window.location.hostname === "localhost"){
        base = REACT_APP_BASEURL_DEV+"";
    }else if (window.location.hostname === "recaudos-qa.comfenalco.com"){
        base = REACT_APP_BASEURL_QA+"";
    }else if (window.location.hostname === "recaudos.comfenalco.com"){
        base = REACT_APP_BASEURL_PRD+"";
    }else if (window.location.hostname === "recaudos-aks.comfenalco.com"){
        base = REACT_APP_BASEURL_AKS+"";
    }
    return base+"ConsultarTrabajadores";
}

const baseUrl_empresa = () => {
    let base = ""
    if(window.location.hostname === "localhost"){
        base = REACT_APP_BASEURL_DEV+"";
    }else if (window.location.hostname === "recaudos-qa.comfenalco.com"){
        base = REACT_APP_BASEURL_QA+"";
    }else if (window.location.hostname === "recaudos.comfenalco.com"){
        base = REACT_APP_BASEURL_PRD+"";
    }else if (window.location.hostname === "recaudos-aks.comfenalco.com"){
        base = REACT_APP_BASEURL_AKS+"";
    }
    return base+"ConsultarEmpresas/";
}

const guardarLocalStorage = (bar: any, foo: any) => {
    localStorage.setItem(bar, foo);
}

const leerLocalStorage = (bar: any) => {
    return localStorage.getItem(bar);
}

const JWT = async (aplicacion: string) => {
    let token: any = leerLocalStorage('TOKEN_'+aplicacion);
    let resp;
    if(typeof token == "undefined" || token == null){
       resp = await obtenerTokenSeguridad(aplicacion);
    } else if(isExpired(token)){
       resp = await obtenerTokenSeguridad(aplicacion);
    }

    if (resp?.data.exito) {
        guardarLocalStorage('TOKEN_'+aplicacion, resp.data.data.token);
    }
    
    token =  leerLocalStorage('TOKEN_'+aplicacion);
    return token;
}

const XHR = async (stpb: React.Dispatch<React.SetStateAction<boolean>> | null, 
                   _url: string, _data: object = {}, 
                   _method: any = 'post', _headers: any = {}) => {
    if(stpb !== null){
        stpb(true);
    }
    var resp = await axios({
                        method: _method,
                        url: _url,
                        headers: _headers,
                        data: _data,
                    }).then(function (response) {
                        return response;
                    }).catch(function (error) {
                        console.error(error);
                    });
    if(stpb !== null){
        stpb(false);
    }
    return resp;
}

async function obtenerTokenSeguridad(aplicacion: string){
    const data : tramaSeguridad =  {
        //identificador: REACT_APP_SEGURIDAD_USER+"",
        //clave: REACT_APP_SEGURIDAD_PASS+"",
        identificador: "",
        clave: "",
        appLlave : "",
        appToken : ""
    };
    data.appLlave = REACT_APP_LLAVE+"";
    data.appToken = REACT_APP_TOKEN+"";  
    
    //var resp = await XHR(null, baseUrl_seguridad()+"", data);
    //var url_payco = "https://secure.epayco.co/validation/v1/reference/" + ref;
    const resp = await axios.post(baseUrl_seguridad()+"", data);
   return resp;
}

function llaveEpayco(){
    return REACT_APP_EPAYCO_LLAVE;
}

function valortotalDocumentosSeleccionados(estado: Iestado) {
    let total: number = 0;
    const keys = Object.keys(estado.referencias);
    keys.forEach((ref) => {
        /*if(estado.referencias[ref].hacer_abono && estado.referencias[ref].valor_abono !== 0){
            console.log("hacer abono");
            total += estado.referencias[ref].valor_abono;
        }else{
            console.log("hacer minimo");
            total += estado.referencias[ref].valorMinimo;
        }*/
        if(estado.referencias[ref].tipoPago == "min"){
            total += estado.referencias[ref].valorMinimo;
        }else if(estado.referencias[ref].tipoPago == "tot"){
            total += estado.referencias[ref].valorTotal;
        }else if(estado.referencias[ref].tipoPago == "otr"){
            total += estado.referencias[ref].valor_abono;
        }

    });
    return total;
  }

export {baseUrl, baseUrl_tDocumento, baseUrl_seguridad, baseUrl_trabajador, guardarLocalStorage, 
        leerLocalStorage, JWT, XHR, llaveEpayco, valortotalDocumentosSeleccionados, baseUrl_empresa}